"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Request = void 0;

var _defaultInterceptor = require("./default-interceptor");

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * 1. 致力于统一前端请求的API
 * 2. 与平台无关, 主要兼容 weapp 和 web 
 * 
 * weapp https://developers.weixin.qq.com/miniprogram/dev/api/network/request/wx.request.html
 * web https://developer.mozilla.org/zh-CN/docs/Web/API/Fetch_API/Using_Fetch
 * 
 * 拙劣的借鉴+抄袭: https://github.com/axios/axios
 */

/**
 * 请求构造器
 * #h5 env
 */


var Request = /*#__PURE__*/function () {
  function Request(requestEngine, config, interceptors) {
    _classCallCheck(this, Request);

    _defineProperty(this, "config", {
      baseUrl: '',
      method: 'GET'
    });

    _defineProperty(this, "requestEngine", void 0);

    _defineProperty(this, "interceptors", void 0);

    this.requestEngine = requestEngine;
    this.config = _objectSpread(_objectSpread({}, this.config), config);
    this.interceptors = {
      request: [_defaultInterceptor.defaultRequestInterceptor].concat(_toConsumableArray((interceptors === null || interceptors === void 0 ? void 0 : interceptors.request) || [])),
      response: [[_defaultInterceptor.defaultResponseInterceptor, _defaultInterceptor.defaultErrorInterceptor]].concat(_toConsumableArray((interceptors === null || interceptors === void 0 ? void 0 : interceptors.response) || []))
    };
  }

  _createClass(Request, [{
    key: "run",
    value: function run(config) {
      var _this = this;

      var mergedConfig = _objectSpread(_objectSpread({}, this.config), config); // 执行拦截器


      mergedConfig = this.interceptors.request.reduce(function (config, interceptor) {
        return interceptor(config);
      }, mergedConfig);
      mergedConfig.headers = _objectSpread(_objectSpread({}, mergedConfig.headers), config.headers);
      return this.requestEngine(mergedConfig).then(function (response) {
        return _this.interceptors.response.reduce(function (response, interceptor) {
          return response.then(interceptor[0])["catch"](interceptor[1]);
        }, Promise.resolve(response));
      });
    }
  }]);

  return Request;
}();

exports.Request = Request;